(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8305],{

/***/ 28830:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[utc]",
      function () {
        return __webpack_require__(15762);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PUBLISHED_ONLY_TOURNAMENT_CONFIG": function() { return /* binding */ PUBLISHED_ONLY_TOURNAMENT_CONFIG; },
/* harmony export */   "ROUTER_OPTIONS": function() { return /* binding */ ROUTER_OPTIONS; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73292);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var next_superjson_plugin_tools__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8396);
/* harmony import */ var next_superjson_plugin_tools__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_superjson_plugin_tools__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48542);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _components_calendar_selectable_event_SelectableEventsCalendar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14262);







var __N_SSG = true;
var PUBLISHED_ONLY_TOURNAMENT_CONFIG = "(NOT phase:unpublished) OR (phase:finished AND visibility:unlisted)";
var ROUTER_OPTIONS = "PATH";
var HomePage = function() {
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("title", {
                    children: "Home - BluMint"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                sx: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__._)({
                    px: {
                        md: 2,
                        xs: 0
                    },
                    pt: 2
                }, theme.breakpoints.down(375), {
                    mx: "-8px",
                    pt: 0
                }),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_calendar_selectable_event_SelectableEventsCalendar__WEBPACK_IMPORTED_MODULE_2__/* .SelectableEventsCalendar */ .w, {
                    routerOptions: ROUTER_OPTIONS
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,next_superjson_plugin_tools__WEBPACK_IMPORTED_MODULE_0__.withSuperJSONPage)(HomePage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8396,1655,4510,4262,9774,2888,179], function() { return __webpack_exec__(28830); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);